import { useSelector } from 'react-redux'
import { Grid } from '@mui/material'

import Select from '../Select'
import { useSelectionSet } from '../../hooks/selection-set-functions'
import { useGetCampionatiQuery } from '../../hooks/api-slice'

const SelectCampionato = () => {
  const { data: campionati } = useGetCampionatiQuery()
  const selectedCampionato = useSelector(
    state => state.selection.selectedCampionato,
  )
  const availableCampionati = useSelector(
    state => state.selection.availableCampionati,
  )

  const { setSelectedCampionato } = useSelectionSet()

  const value = availableCampionati?.includes(selectedCampionato)
    ? selectedCampionato
    : undefined

  const optionLabels = availableCampionati?.map(
    a => campionati?.find(c => c.codice === a)?.nome,
  )

  return (
    <Grid size={{ xs: 12, md: 3 }}>
      <Select
        id='available-campionati'
        label='Campionato'
        value={value}
        options={availableCampionati}
        optionLabels={optionLabels}
        disabled={!availableCampionati}
        onChange={setSelectedCampionato}
      />
    </Grid>
  )
}

export default SelectCampionato
